import React from "react";
import FeatureItem from "./FeatureItem";

export default function Features(props) {
    const featureItems = props.items.map((item, index) => {
        return (
            <FeatureItem
                title={item.title}
                image={item.icon}
                active={props.selectedFeatureIndex === index}
                onClick={() => {
                    props.onSelectFeature(item, index);
                }}
            />
        );
    });
    return <ul className="mba-features-nav">{featureItems}</ul>;
}
